import { render, staticRenderFns } from "./InformPayment.vue?vue&type=template&id=1f14e9a2&scoped=true&"
import script from "./InformPayment.vue?vue&type=script&lang=js&"
export * from "./InformPayment.vue?vue&type=script&lang=js&"
import style0 from "./InformPayment.vue?vue&type=style&index=0&id=1f14e9a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f14e9a2",
  null
  
)

export default component.exports